import { inferSalePathKind, parseRtoLessor } from "@/lib/opsDealTypes/saleTypeProviders";

export function DealTypesSaleProviders(props: {
  typeKey: string;
  displayName: string;
  metadata: Record<string, unknown>;
  rtoLessor: string;
  setRtoLessor: (v: string) => void;
  financeSourcesText: string;
  setFinanceSourcesText: (v: string) => void;
}) {
  const kind = inferSalePathKind(props.typeKey, props.displayName);
  if (kind === "cash") {
    return (
      <p className="text-xs text-gray-500 dark:text-zinc-400">
        Cash has no lessor or lender. Use an RTO or Finance sale type to name providers.
      </p>
    );
  }
  if (kind === "rto") {
    return (
      <label className="block text-sm text-gray-700 dark:text-zinc-300">
        Active RTO lessor
        <input
          className="mt-1 block w-full rounded border border-gray-300 px-2 py-1.5 dark:border-zinc-600 dark:bg-zinc-900"
          value={props.rtoLessor}
          onChange={(e) => props.setRtoLessor(e.target.value)}
          placeholder="Org-configured lessor name"
        />
        <span className="mt-1 block text-xs text-gray-500">One active lessor for this sale type. Not hardcoded.</span>
      </label>
    );
  }
  if (kind === "finance") {
    return (
      <label className="block text-sm text-gray-700 dark:text-zinc-300">
        Finance sources
        <textarea
          className="mt-1 block w-full rounded border border-gray-300 px-2 py-1.5 dark:border-zinc-600 dark:bg-zinc-900"
          rows={3}
          value={props.financeSourcesText}
          onChange={(e) => props.setFinanceSourcesText(e.target.value)}
          placeholder={"One lender per line"}
        />
        <span className="mt-1 block text-xs text-gray-500">
          One lender per line. Org-authored, not hardcoded.
        </span>
      </label>
    );
  }
  return (
    <p className="text-xs text-gray-500 dark:text-zinc-400">
      Name this sale type Cash, Finance, or RTO to set the lessor or lenders. Current stored lessor:{" "}
      {parseRtoLessor(props.metadata) || "none"}.
    </p>
  );
}
